import React, {SyntheticEvent} from 'react';
import ModalV4 from '../../../app/ui/modal/v4/v4';
import ItemViewTop from "../../../layout/top/item-view-top/item-view-top";
import ErrorBoundary from "../../error-boundary";
import ButtonSubmit from "../../gd-form/common/btn-submit/btn-submit-ui5-new";
import AttendanceEvent from "../../model2/attendance-event/attendance-event";
import FormModel from "../../gd-form/common/form-model-manager";
import FieldFormElement from "../../fields3/render/form-elemnent";
import AttendanceFields from "../../model2/attendance-event/fields";
import FormFieldError from "../../gd-form/common/form-error/form-field-error";
import FormFlex from "../../gd-form/form/form-flex/form";
import FormRowFlex from "../../gd-form/form/form-flex/row";
import {AttendanceType} from "../../model2/attendance-event/const";

type Props = {
    params: {
        onSubmit: callback
    }
}

export default class ModalClockIn extends ModalV4 {

    public clockInForm    : FormModel
    public clockInEvent   : AttendanceEvent
    public fields         : AttendanceFields  = new AttendanceFields()

    constructor(props: Props) {
        super(props);

        this.clockInEvent = new AttendanceEvent({
            type            : AttendanceType.CLOCKED_IN,
            createdByUserId : gd.user.id,
            officeId        : gd.session.offices.models[0] ? gd.session.offices.models[0].id : null
        })
        this.clockInForm    = new FormModel(this.clockInEvent,{
            onSubmit: this.props.params.onSubmit
        })
    }

    onClick = (e: SyntheticEvent) => {
        e.stopPropagation();
        e.preventDefault();
    }


    render() {
        const topLeftContent = <div className="ui5-txt-not-important-small">Clock in</div>

        return (
            <div className="v4-container placement-middle ui5-iv" style={{width: 840, height: 600}} onClick={this.onClick}>
                <ItemViewTop leftContent={topLeftContent} onCloseClick={this.closeModal}/>
                <div className="iv-left-column iv-column">
                    <div className="details-big-icon">
                        <div className="isvg isvg-clock-in-out"/>
                    </div>
                </div>
                <ErrorBoundary>
                    <div className="iv-cf-form">
                        <div className="iv-header header-left header-small-no-separator m-t-30 m-l-20">
                            <div className="title-line">
                                <div className="view-name">
                                    <div className="ui5-title-app-name max-w-350">
                                        Clock In
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="iv-content with-left-panel">
                            <div className="p-l-30">
                                <FormFlex className="m-t-40 m-l-20">
                                    <FormRowFlex width={150} label="Location" field={this.fields.officeId} form={this.clockInForm}>
                                        <FieldFormElement className = "w-300"
                                                          form      = {this.clockInForm}
                                                          field     = {this.fields.officeId}
                                                          model     = {this.clockInEvent}/>
                                        <FormFieldError form={this.clockInForm} field={this.fields.officeId} className="w-200"/>
                                    </FormRowFlex>
                                    <FormRowFlex width={150} label="Comment" field={this.fields.date} form={this.clockInForm}>
                                        <FieldFormElement className = "w-300"
                                                          form      = {this.clockInForm}
                                                          field     = {this.fields.comment}
                                                          model     = {this.clockInEvent}/>
                                    </FormRowFlex>
                                    <FormRowFlex width={150} form={this.clockInForm}>
                                        <ButtonSubmit className = "submit w-100"
                                                      form      = {this.clockInForm}
                                                      label     = "Submit"/>
                                    </FormRowFlex>
                                </FormFlex>
                            </div>
                        </div>
                    </div>
                </ErrorBoundary>
            </div>
        )
    }
}
